<template>
  <Modal v-if="showOpenConfirmation" @close="$emit('closeModal')">
    <div class="openConfirmation">
      <div class="openConfirmation__header">
        <span class="title">{{ $t('confirmation') }}</span>
        <img
          class="openConfirmation__header-img"
          src="@/assets/icons/CloseModal.svg"
          alt="Close Modal"
          @click="$emit('closeModal')"
        />
      </div>
      <div class="openConfirmation__body">
        <p class="text">
          {{ $t('confirmationText') }}
        </p>
      </div>
      <div class="openConfirmation__buttons">
        <Button
          class="openConfirmation__button"
          variant="filled"
          :title="$t('confirm')"
          @click="$emit('confirmRequest')"
        />
        <Button
          variant="notBordered"
          :title="$t('cancel')"
          @click="$emit('closeModal')"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'OpenConfirmation',
  props: ['showOpenConfirmation']
})
export default class OpenConfirmation extends Vue {}
</script>

<style lang="scss" scoped>
.openConfirmation {
  max-width: 385px;
  height: 100%;
  padding: 24px;
  .openConfirmation__header {
    display: flex;
    justify-content: space-between;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
    }
    .openConfirmation__header-img {
      cursor: pointer;
    }
  }
  .openConfirmation__body {
    padding: 24px 0;
    .text {
      color: $label;
      font-size: $fourteenSize;
      line-height: $twentyTwoSize;
      font-weight: 500;
    }
  }
  .openConfirmation__buttons {
    .openConfirmation__button {
      margin-right: 12px;
    }
  }
}
</style>
